'use strict';

module.exports = ['$scope', '$mdDialog', 'imgUrl', 'element',
    function ($scope, $mdDialog, imgUrl, element) {
        let currentEl = element;

        $scope.imgUrl = imgUrl;

        /*
        $scope.close = () => {
            $mdDialog.hide();
        };
        let onkeydown = (event) => {
            if(event.keyCode == 39) {//right arrow

                let nextEl = currentEl.next();
                if(nextEl.length == 0) {
                    nextEl = currentEl.siblings();
                }
                currentEl =  nextEl;
                $scope.imgUrl = nextEl.find('img').attr('src');
            } else if(event.keyCode == 37) {//left arrow

                let prevEl = currentEl.prev();
                if(prevEl.length == 0) {
                    prevEl = currentEl.siblings();
                }
                currentEl = prevEl;
                $scope.imgUrl = prevEl.find('img').attr('src');
            } else {
                angular.element(document).unbind('keydown', onkeydown);
                $mdDialog.hide();
            }
        };

        angular.element(document).bind('keydown', onkeydown);
        */
    }
];

